export default __webpack_public_path__ + "static/media/mons6.4037a980.jpg";